let highlightInitialized = false;

document.addEventListener('click', (event) => {
  const clickedElement = event.target.closest('.showing-question');

  if (clickedElement && !highlightInitialized) {
    highlightInitialized = true; // Ensures it only runs after the first click
    highlightNotCompleted();
  }
});



function updateSummary() {
  const summaryContainer = document.querySelector('.product-options-summary__info');
  summaryContainer.innerHTML = '';

  const allOptions = document.querySelectorAll('.product-option-custom');
  let qaData = {}; // JSON object to store Q&A pairs

  allOptions.forEach((option, index) => {
    // Try to find question in the old structure first
    let questionLabel = option.querySelector('.product-option-custom__question')?.textContent.trim();
    
    // If not found, look for label > p structure
    if (!questionLabel) {
      const labelElement = option.querySelector('label[for="custom-input"] p');
      if (labelElement) {
        questionLabel = labelElement.textContent.trim();
      }
    }
    
    // If still not found, try any label with text
    if (!questionLabel) {
      const anyLabel = option.querySelector('label');
      if (anyLabel) {
        questionLabel = anyLabel.textContent.trim();
      }
    }
    
    if (!questionLabel) {
      return;
    }

    let answers = [];

    // Get selected options (checkboxes, radio buttons)
    option.querySelectorAll('label.selected p').forEach(selectedOption => {
      answers.push(selectedOption.textContent.trim());
    });

    // Get text inputs
    option.querySelectorAll('input[type="text"]').forEach(textInput => {
      if (textInput.value.trim() !== '') {
        answers.push(textInput.value.trim());
      }
    });

    // Get file input name
    const fileInput = option.querySelector('input[type="file"]');
    if (fileInput && fileInput.files.length > 0) {
      answers.push(fileInput.files[0].name);
    } 

    // Only add to JSON if there are answers
    if (answers.length > 0) {
      // For duplicate questions, append a counter
      let uniqueKey = questionLabel;
      if (qaData.hasOwnProperty(questionLabel)) {
        let counter = 2;
        while (qaData.hasOwnProperty(`${questionLabel} (${counter})`)) {
          counter++;
        }
        uniqueKey = `${questionLabel} (${counter})`;
      }
      
      qaData[uniqueKey] = answers.join(', ');
      
      // Add to UI summary
      const summaryItem = document.createElement('div');
      summaryItem.classList.add('summary-item');
      summaryItem.innerHTML = `<strong>${questionLabel}:</strong> ${answers.join(', ')}`;
      summaryContainer.appendChild(summaryItem);
    }
  });

  // Convert to a format that works with the cart's simple parsing
  // Format: "key1":"value1","key2":"value2"
  let cartFormattedData = '';
  Object.entries(qaData).forEach(([question, answer], index) => {
    if (index > 0) cartFormattedData += ',';
    // Remove problematic characters that break the cart's parsing
    const cleanQuestion = question.replace(/[":,]/g, ' ').trim();
    const cleanAnswer = answer.replace(/[":,]/g, ' ').trim();
    cartFormattedData += `"${cleanQuestion}":"${cleanAnswer}"`;
  });
  
  // Wrap in curly braces to make it look like JSON
  cartFormattedData = `{${cartFormattedData}}`;
  
  // Store in _qa_data for the cart to parse
  document.querySelector('input[name="properties[_qa_data]"]').value = cartFormattedData;
  
  // Also create a human-readable version
  let readableData = '';
  
  // Function to convert text to Unicode bold
  function toBold(text) {
    const bold = {
      'A': '𝗔', 'B': '𝗕', 'C': '𝗖', 'D': '𝗗', 'E': '𝗘', 'F': '𝗙', 'G': '𝗚', 'H': '𝗛', 'I': '𝗜',
      'J': '𝗝', 'K': '𝗞', 'L': '𝗟', 'M': '𝗠', 'N': '𝗡', 'O': '𝗢', 'P': '𝗣', 'Q': '𝗤', 'R': '𝗥',
      'S': '𝗦', 'T': '𝗧', 'U': '𝗨', 'V': '𝗩', 'W': '𝗪', 'X': '𝗫', 'Y': '𝗬', 'Z': '𝗭',
      'a': '𝗮', 'b': '𝗯', 'c': '𝗰', 'd': '𝗱', 'e': '𝗲', 'f': '𝗳', 'g': '𝗴', 'h': '𝗵', 'i': '𝗶',
      'j': '𝗷', 'k': '𝗸', 'l': '𝗹', 'm': '𝗺', 'n': '𝗻', 'o': '𝗼', 'p': '𝗽', 'q': '𝗾', 'r': '𝗿',
      's': '𝘀', 't': '𝘁', 'u': '𝘂', 'v': '𝘃', 'w': '𝘄', 'x': '𝘅', 'y': '𝘆', 'z': '𝘇',
      '0': '𝟬', '1': '𝟭', '2': '𝟮', '3': '𝟯', '4': '𝟰', '5': '𝟱', '6': '𝟲', '7': '𝟳', '8': '𝟴', '9': '𝟵'
    };
    return text.split('').map(char => bold[char] || char).join('');
  }
  
  Object.entries(qaData).forEach(([question, answer], index) => {
    if (index > 0) readableData += '\n\n━━━━━━━━━━━━━━━━━━━━\n\n'; // Add a visual separator line
    readableData += `${question}:\n${toBold(answer)}`;
  });
  
  // Store the readable version in a separate property
  const readableInput = document.querySelector('input[name="properties[_qa_data_readable]"]');
  if (readableInput) {
    readableInput.value = readableData.trim();
  }
   
}




function checkConditions() {
  console.log('=== Running checkConditions ===');
  const options = document.querySelectorAll('.product-option-custom');

  options.forEach(option => {
    let showOption = true;

    option.classList.remove('highlighted');

    // Get conditions from the schema
    const targetedLabelOne = option.dataset.targetedLabelOne;
    const targetedAnswerOne = option.dataset.targetedAnswerOne;
    const targetedLabelOneOr = option.dataset.targetedLabelOneOr;
    const targetedAnswerOneOr = option.dataset.targetedAnswerOneOr;

    const targetedLabelOneOr2 = option.getAttribute('data-targeted-label-one-or-2');
    const targetedAnswerOneOr2 = option.getAttribute('data-targeted-answer-one-or-2');
    const targetedLabelOneOr3 = option.getAttribute('data-targeted-label-one-or-3');
    const targetedAnswerOneOr3 = option.getAttribute('data-targeted-answer-one-or-3');
    const targetedLabelOneOr4 = option.getAttribute('data-targeted-label-one-or-4');
    const targetedAnswerOneOr4 = option.getAttribute('data-targeted-answer-one-or-4');
    const targetedLabelOneOr5 = option.getAttribute('data-targeted-label-one-or-5');
    const targetedAnswerOneOr5 = option.getAttribute('data-targeted-answer-one-or-5');

    const targetedLabelTwo = option.dataset.targetedLabelTwo;
    const targetedAnswerTwo = option.dataset.targetedAnswerTwo;
    const targetedLabelTwoOr = option.dataset.targetedLabelTwoOr;
    const targetedAnswerTwoOr = option.dataset.targetedAnswerTwoOr;
    const targetedLabelThree = option.dataset.targetedLabelThree;
    const targetedAnswerThree = option.dataset.targetedAnswerThree;
    const targetedLabelThreeOr = option.dataset.targetedLabelThreeOr;
    const targetedAnswerThreeOr = option.dataset.targetedAnswerThreeOr;

    function checkCondition(label, answer, ...additionalConditions) {
      let match = false;

      // Check main condition
      if (label && answer) {
        const element = document.querySelector(`[name="properties[${label}]"]`);
        if (element) {
          const selectedIndex = parseInt(element.getAttribute('value'), 10);
          const answerPositions = answer.split(' | ').map(Number);
          if (answerPositions.includes(selectedIndex)) {
            match = true;
          }
        }
      }

      // Check all additional OR conditions if main condition failed
      if (!match) {
        for (const condition of additionalConditions) {
          const { label: orLabel, answer: orAnswer } = condition;
          if (orLabel && orAnswer) {
            const elementOr = document.querySelector(`[name="properties[${orLabel}]"]`);
            if (elementOr) {
              const selectedIndexOr = parseInt(elementOr.getAttribute('value'), 10);
              const answerPositionsOr = orAnswer.split(' | ').map(Number);
              if (answerPositionsOr.includes(selectedIndexOr)) {
                match = true;
                break; // Exit loop if any OR condition matches
              }
            }
          }
        }
      }

      return match;
    }

    // Check the conditions only if the values are not all blank
    let conditionOneMatched = true;
    if (
      targetedLabelOne ||
      targetedAnswerOne ||
      targetedLabelOneOr ||
      targetedAnswerOneOr ||
      targetedLabelOneOr2 ||
      targetedAnswerOneOr2 ||
      targetedLabelOneOr3 ||
      targetedAnswerOneOr3 ||
      targetedLabelOneOr4 ||
      targetedAnswerOneOr4 ||
      targetedLabelOneOr5 ||
      targetedAnswerOneOr5
    ) {
      conditionOneMatched = checkCondition(
        targetedLabelOne,
        targetedAnswerOne,
        { label: targetedLabelOneOr, answer: targetedAnswerOneOr },
        { label: targetedLabelOneOr2, answer: targetedAnswerOneOr2 },
        { label: targetedLabelOneOr3, answer: targetedAnswerOneOr3 },
        { label: targetedLabelOneOr4, answer: targetedAnswerOneOr4 },
        { label: targetedLabelOneOr5, answer: targetedAnswerOneOr5 }
      );
    }

    let conditionTwoMatched = true;
    if (targetedLabelTwo || targetedAnswerTwo || targetedLabelTwoOr || targetedAnswerTwoOr) {
      conditionTwoMatched = checkCondition(
        targetedLabelTwo,
        targetedAnswerTwo,
        { label: targetedLabelTwoOr, answer: targetedAnswerTwoOr }
      );
    }

    let conditionThreeMatched = true;
    if (targetedLabelThree || targetedAnswerThree || targetedLabelThreeOr || targetedAnswerThreeOr) {
      conditionThreeMatched = checkCondition(
        targetedLabelThree,
        targetedAnswerThree,
        { label: targetedLabelThreeOr, answer: targetedAnswerThreeOr }
      );
    }

    // If any of the conditions fail, hide the option
    if (!conditionOneMatched || !conditionTwoMatched || !conditionThreeMatched) {
      showOption = false;
    }

    // Get the question title for logging
    const questionTitle = option.querySelector('.product-option-custom__question')?.textContent.trim() || 
                         option.querySelector('label')?.textContent.trim() || 
                         'Unknown Question';
    
    // Show or hide the option based on the conditions
    if (showOption) {
      console.log(`✅ Showing: "${questionTitle}"`);
      option.style.display = 'flex';
      option.classList.add('showing-question');


      if(option.parentElement.querySelector('.product-option-custom-info__wrap')) {
        option.parentElement.querySelector('.product-option-custom-info__wrap').style.display = 'block';
      }


    } else {
      console.log(`❌ Hiding: "${questionTitle}"`);
      option.style.display = 'none';
      option.classList.remove('showing-question');

      if(option.parentElement.querySelector('.product-option-custom-info__wrap')) {
        option.parentElement.querySelector('.product-option-custom-info__wrap').style.display = 'none';
      }

      const select = option.querySelector('.po-image');
      const labels = option.querySelectorAll('label');
      const inputs = option.querySelectorAll('input[type="checkbox"], input[type="radio"]');

      if (labels) {
        labels.forEach(label => {
          label.classList.remove('selected');
        });
      }
      
      // Reset all inputs
      if (inputs) {
        inputs.forEach(input => {
          input.checked = false;
        });
      }

      // Reset to default value
      if (select) {
        select.setAttribute('value', '0');
      }
    }
  });

  initializeFileUploads();
  initializeImageSelects();
  updateSummary();
  getPrices();

  if (highlightInitialized){
    highlightNotCompleted();
  }
  
}

function textInputsState() {
  const textInputs = document.querySelectorAll('.product-option-custom input[type="text"]');

  textInputs.forEach(input => {
    input.addEventListener('input', function () {
      

      const currentWrap = input.closest('.product-option-custom-wrap');
      

      const allWraps = Array.from(document.querySelectorAll('.product-option-custom-wrap'));
      const currentIndex = allWraps.indexOf(currentWrap);

      if (currentIndex > -1 && currentIndex < allWraps.length - 1) {
        const nextWrap = allWraps[currentIndex + 1];
        

        if (nextWrap.classList.contains('typogrpahy')) {
          
          // 🔽 Add your logic here

          const typographySwatches = nextWrap.querySelectorAll('.has-image'); 
          const textBox = nextWrap.querySelector('.written-text');
          const textBoxP = textBox.querySelector('p');
          const textBoxTop = textBox.getBoundingClientRect().top + window.pageYOffset;

          typographySwatches.forEach(swatch => {

            swatch.addEventListener('click', function () {

              //scroll to position textBox at bottom of viewport
              const textBoxBottom = textBox.getBoundingClientRect().bottom + window.pageYOffset;
              const viewportHeight = window.innerHeight;
              const scrollPosition = textBoxBottom - viewportHeight;
              
              window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth',
              });

    

              if (swatch.hasAttribute('data-style')) {
                const styleString = swatch.getAttribute('data-style');
                textBoxP.style.cssText = styleString;
                
                
              }
 
            });

          })



         
          textBox.classList.add('show');

          textBoxP.innerHTML = input.value;
        }
      } else {
        
      }

      if (input.value.trim() !== '') {
        input.closest('.product-option-custom').classList.remove('highlighted');
      } else {
        input.closest('.product-option-custom').classList.add('highlighted');
      }
    });
  });
}

// Function to initialize image select event listeners
function initializeImageSelects() {
  const imageSelect = document.querySelectorAll('.po-image');

  imageSelect.forEach(selection => {
    // Skip if element is not visible
    const parentOption = selection.closest('.product-option-custom');
    if (!parentOption || parentOption.style.display === 'none') {
      return;
    }
    
    // Get all inputs and remove existing click listeners by cloning
    const inputs = selection.querySelectorAll('input');
    
    inputs.forEach(input => {
      // Store current state
      const isChecked = input.checked;
      const labelHasSelected = input.closest('label').classList.contains('selected');
      
      // Clone to remove listeners
      const newInput = input.cloneNode(true);
      input.parentNode.replaceChild(newInput, input);
      
      // Restore state
      newInput.checked = isChecked;
      if (labelHasSelected) {
        newInput.closest('label').classList.add('selected');
      }
      
      // Add new listener
      if (selection.classList.contains('images-multi')) {
        newInput.addEventListener('click', function () {
          if (newInput.checked) {
            newInput.closest('label').classList.add('selected');
          } else {
            newInput.closest('label').classList.remove('selected');
          }
          checkConditions();
        });
      } else {
        newInput.addEventListener('click', function () {
          // Clear all options in this selection
          selection.querySelectorAll('input').forEach(opt => {
            opt.checked = false;
            opt.closest('label').classList.remove('selected');
          });
          // Select this one
          newInput.checked = true;
          newInput.closest('label').classList.add('selected');
          selection.setAttribute('value', newInput.value);
          checkConditions();
        });
      }
    });
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function () {
  checkConditions();
  textInputsState()
  listenForAddToCart();

  if (Shopify.designMode) {
    document.body.classList.add('in-customizer');
  }

  initializeImageSelects();
  initializeFileUploads();
});

function initializeFileUploads() {
  const fileUploadContainers = document.querySelectorAll('.file-upload-container');

  fileUploadContainers.forEach(container => {
    const fileInput = container.querySelector('input[type="file"]');
    const dropArea = container;

    // Find the corresponding hidden input in the product form
    const productFormInput = document.querySelector('#product-form-uplaod');

    if (!fileInput || !productFormInput) {
      
      return;
    }

    // Drag-and-drop handling
    dropArea.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropArea.classList.add('drag-over');
    });

    dropArea.addEventListener('dragleave', () => {
      dropArea.classList.remove('drag-over');
    });

    dropArea.addEventListener('drop', (e) => {
      e.preventDefault();
      dropArea.classList.remove('drag-over');

      const droppedFiles = e.dataTransfer?.files; // Correctly fetch the files
      if (droppedFiles && droppedFiles.length) {
        fileInput.files = droppedFiles; // Assign the files to the custom question input
        updateFileLabel(container, droppedFiles[0].name); // Update the custom question UI
        productFormInput.files = droppedFiles; // Sync the file with the product form input
      }
    });

    // Input change handling
    fileInput.addEventListener('change', () => {
      const selectedFiles = fileInput.files; // Fetch the selected files
      if (selectedFiles && selectedFiles.length) {
        updateFileLabel(container, selectedFiles[0].name); // Update the custom question UI
        productFormInput.files = selectedFiles; // Sync the file with the product form input
      }
    });
  });
}

function updateFileLabel(container, fileName) {
  const label = container.querySelector('p'); // Target the <p> inside the same container
  if (label) {
    label.textContent = fileName; // Update the text to the uploaded file name
  } else {
    console.warn("Label element missing in file-upload-container");
  }
}


const highlightNotCompleted = () => {
  const allOptionsShowing = document.querySelectorAll('.showing-question');
  // Check if last selected swatch is in typography section
  const lastHasImageSelected = Array.from(document.querySelectorAll('label.selected')).pop();
  
  let skipScrollingToQuestions = false;
  if (lastHasImageSelected && lastHasImageSelected.parentElement.parentElement.parentElement.classList.contains('typogrpahy')) {
    const typographyWrap = lastHasImageSelected.closest('.typogrpahy');

    if (typographyWrap) {
      skipScrollingToQuestions = true; // ❌ Do NOT scroll to questions, but still allow finished logic
    }
  }



  let needsScrolling = false;



  

  Array.from(allOptionsShowing).some(option => {
    const labels = option.querySelectorAll('label');
    const textInputs = option.querySelectorAll('input[type="text"]'); 
    const checkboxes = option.querySelectorAll('input[type="checkbox"]');
    let selected = false;

    // Check if any label is selected
    labels.forEach(label => {      
      if (label.classList.contains('selected')) {
        selected = true;
      }
    });

    // Check if any checkbox is selected
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        selected = true;
      }
    });

    // Check if any text input has a value
    textInputs.forEach(input => {
      if (input.value.trim() !== '') {
        selected = true;
      }
    });

    // If no selections or inputs are completed, scroll to this option
    if (!selected) {
      needsScrolling = true;
      
      // Only scroll to questions if not in typography mode
      if (!skipScrollingToQuestions) {
        const optionTop = option.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
          top: optionTop - 200,
          behavior: 'smooth',
        });

        option.classList.add('highlighted');

        option.animate(
          [
            { transform: 'translateX(-0.75px)' },
            { transform: 'translateX(0.75px)' },
            { transform: 'translateX(-0.75px)' },
            { transform: 'translateX(0.75px)' },
          ],
          { duration: 800, iterations: 1 }
        );

        //if input focus
        const input = option.querySelector('input[type="text"]');
        if (input) {
          input.focus();
        }
      } else {
        // Still highlight the question even if not scrolling
        option.classList.add('highlighted');
      }

      return true; // Stop iterating after finding the first incomplete option
    }

    return false; // Continue the loop
  });

  const finishedElement = document.querySelector('#product-options-summary');

  // Check if the last visible question is a text input
  const lastVisibleQuestion = Array.from(allOptionsShowing).pop();
  const hasTextInput = lastVisibleQuestion?.querySelector('input[type="text"]');
  
  
  // Show finished section if:
  // 1. No scrolling needed (all questions complete), OR
  // 2. There are incomplete questions BUT the last question is a text input
  const shouldShowFinished = !needsScrolling || (needsScrolling && hasTextInput);
  
  if (shouldShowFinished) {
    if (finishedElement) {
      finishedElement.classList.add('highlighted');
      
      // Only scroll if all questions are complete AND last question is NOT a text input
      if (!needsScrolling && !hasTextInput) {
        const optionTop = finishedElement.getBoundingClientRect().top + window.pageYOffset;
        finishedElement.scrollIntoView({ behavior: 'smooth' });

        //scroll to finished element
        window.scrollTo({
          top: optionTop - 200,
          behavior: 'smooth',
        });
      }
    }
  } else {
    if (finishedElement) {
      finishedElement.classList.remove('highlighted');
    }
  }
};

let addonsItemsToBeAddedToCart = [];

const getPrices = () => {
  const allOptions = document.querySelectorAll('.product-option-custom');
  const variantPrice = (document.querySelector('variant-selects')?.getAttribute('varient-selected-price')) || (document.querySelector('.js-no-vars')?.getAttribute('varient-selected-price'));
  
  let prices = parseInt(variantPrice);
  addonsItemsToBeAddedToCart = [];

  allOptions.forEach(option => {
    const selectedOptions = option.querySelectorAll('label.selected');

      selectedOptions.forEach(selectedOption => {
          const price = selectedOption.getAttribute('data-addon-price');

          if (price) {
              const propertyKey = option.querySelector('.product-option-custom__question').textContent.trim();
              const propertyValue = selectedOption.querySelector('p').textContent.trim();
              const addonVariantId = selectedOption.getAttribute('data-addon-var-id');

              // Push each item to the array instead of using an object with keys
              addonsItemsToBeAddedToCart.push({
                  id: parseInt(addonVariantId), // Ensure ID is a number
                  quantity: 1,
                  properties: {
                      [propertyKey]: propertyValue,
                      "_addon": "Yes"
                  }
              });

              prices += parseFloat(price);
          }
      });
  });

  
  
  const pricToDecimal = (prices / 100).toFixed(2);  
  
    // Get currency symbol from Shopify
    const currencySymbol = window.shopifyCurrencySymbol || '£';
  
    const vat = (prices * 1.2) / 100;
    const vatToDecimal = vat.toFixed(2);


  // document.querySelector('.js-pdp-total-price').innerHTML = pricToDecimal;
  //js-pdp-total-price-vat

  document.querySelectorAll('.js-pdp-total-price').forEach(item => {
    item.innerHTML = currencySymbol + pricToDecimal;
  });



  document.querySelectorAll('.js-pdp-total-price-vat').forEach(item => {
    item.innerHTML = currencySymbol + vatToDecimal;
  });

  return prices;
}

const listenForAddToCart = () => {
  const addToCartButton = document.querySelector('.js-builder-add-to-cart');
  const realAddToCartButton = document.querySelector('.product-form__submit');




  addToCartButton.addEventListener('click', (event) => {
    const isSelected = document.querySelector('.product-options-summary.highlighted');
    const isSendViaContactForm = addToCartButton.classList.contains('send-via-contact-form');
  
    if (!isSelected) {
      
      highlightNotCompleted();
      return;
    }
  
    event.preventDefault();
    addToCartButton.classList.add('loading');
    updateSummary(); // Ensure Q&A data is up to date
  
    if (isSendViaContactForm) {
      const contactForm = document.querySelector('#ContactForm');
      if (!contactForm) {
        
        addToCartButton.classList.remove('loading');
        return;
      }
  
      // Validate required fields
      const name = contactForm.querySelector('#ContactForm-name');
      const email = contactForm.querySelector('#ContactForm-email');
  
      if (!name.value.trim()) {
        alert('Please fill in your name');
        addToCartButton.classList.remove('loading');
        return;
      }
  
      if (!email.value.trim()) {
        alert('Please fill in your email');
        addToCartButton.classList.remove('loading');
        return;
      }
  
      // Optional: email format check
      if (!/^\S+@\S+\.\S+$/.test(email.value)) {
        alert('Please enter a valid email address');
        addToCartButton.classList.remove('loading');
        return;
      }
  
      // Add hidden Q&A input (use readable version for contact form)
      const hiddenInputName = 'contact[Product Options]';
      const qaDataReadable = document.querySelector('input[name="properties[_qa_data_readable]"]').value;
  
      const existingInput = contactForm.querySelector(`input[name="${hiddenInputName}"]`);
      if (existingInput) existingInput.remove();
  
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = hiddenInputName;
      hiddenInput.value = qaDataReadable;
      contactForm.appendChild(hiddenInput);
  
      contactForm.submit();
    } else {
      realAddToCartButton.click(); // standard add to cart
    }
  });
  
  
}

const checkboxes = document.querySelectorAll('.js-checkbox-check'); 

checkboxes.forEach(checkbox => {
  checkbox.addEventListener('click', function() {
    
    highlightNotCompleted();
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const url = new URL(window.location.href);
  if (url.searchParams.get('contact_posted') === 'true') {
    alert("Thanks for contacting us. We'll get back to you as soon as possible.");
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.send-via-contact-form')) {
    // Hide price
    const price = document.querySelector('.pdp-price');
    if (price) price.style.display = 'none';

    // Hide fixed bar
    const fixedBar = document.querySelector('.shopify-section .pdp-fixed-bar__inner .pdp-fixed-bar__right');
    if (fixedBar) fixedBar.style.display = 'none';

    // Hide all product options summary lines
    const summaryLines = document.querySelectorAll('.product-options-summary__line');
    summaryLines.forEach(line => {
      line.style.display = 'none';
    });
  }
});









